var ajaxService = require('./ajaxService');

function requestSender(requests) {
	var serializedRequests = require('./serialize')(requests);
	return ajaxService(serializedRequests, '../request');
}

module.exports = requestSender;